import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmToggleComponent } from './sm-toggle.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [SmToggleComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports:[SmToggleComponent]
})
export class SmToggleModule { }
